module.exports = __webpack_public_path__ + "static/error-clicks-occur-8a64fc5d0870e6bc446b4ff3664fe7ec.png";